import React from 'react';
import ReactDOM from 'react-dom';
import './app/i18n';
import App from './app/App';

ReactDOM.render(
  <App />,
  document.getElementById('app')
);
